export default __webpack_public_path__ + "static/media/Digital-Marketing.c12701be.jpg";